export interface Trip {
  id: string;
  title: string;
  destination: string;
  description: string;
  price: number;
  duration: string;
  image: string;
  category: string;
  group_size: string;
  rating: number;
  highlights: string[];
  availability_status?: string;
  itinerary?: string;
}

// Re-export for backwards compatibility with groupSize naming
export interface TripDisplay extends Trip {
  groupSize: string;
}

export const transformTrip = (trip: Trip): TripDisplay => ({
  ...trip,
  groupSize: trip.group_size,
});

// Generate slug from title
export const generateSlug = (title: string): string => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
};

// Extract ID from slug (if slug contains ID, otherwise we'll use route state)
export const getIdFromSlug = (slug: string): string | null => {
  // For now, we'll rely on route state, but this can be extended
  return null;
};
